/**
 * Hook to track events to GA and optionally to super-admin audit log.
 * Usage: const track = useTrackEvent(); track('button_click', { label: 'Copy summary', category: 'tournament' });
 */

import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useConsent } from '../contexts/ConsentContext';
import { trackEvent as gaTrackEvent } from '../utils/analytics';
import { logUserActivity } from '../services/auditLogService';

export function useTrackEvent() {
  const { currentUser, userProfile } = useAuth();
  const { trackingConsent } = useConsent();

  const track = useCallback((name, params = {}, options = { logToAudit: true }) => {
    gaTrackEvent(name, params, { ...options, trackingConsent });
    if (options.logToAudit && currentUser?.uid) {
      const context = {
        userId: currentUser.uid,
        userEmail: currentUser.email || null,
        displayName: userProfile?.displayName || currentUser.displayName || currentUser.email || null,
      };
      const page = typeof window !== 'undefined' ? window.location.pathname : '';
      const label = params.label || params.category || name;
      logUserActivity(context, name, page, label, { ...params });
    }
  }, [trackingConsent, currentUser?.uid, currentUser?.email, currentUser?.displayName, userProfile?.displayName]);

  return track;
}
